import { EEditorSettingsParamType } from '@wix/editor-settings';

import { i18nInstance } from '../config/i18n';

import {
  DisplaySettings,
  DesignSettings,
  TextSettings,
  LayoutSettings,
  Alignment,
  ImageRatio,
  LayoutType,
} from './types';

export const display: DisplaySettings = {
  showHeaderTitle: {
    defaultValue: true,
    key: 'showHeaderTitle',
    type: EEditorSettingsParamType.Boolean,
  },
  showMemberAvatars: {
    defaultValue: true,
    key: 'showMemberAvatars',
    type: EEditorSettingsParamType.Boolean,
  },
  showMemberCount: {
    defaultValue: true,
    key: 'showMemberCount',
    type: EEditorSettingsParamType.Boolean,
  },
};

export const layout: LayoutSettings = {
  groupListLayout: {
    defaultValue: LayoutType.list,
    key: 'groupListLayout',
    type: EEditorSettingsParamType.String,
  },
  headerAlignment: {
    defaultValue: Alignment.left,
    key: 'headerAlignment',
    type: EEditorSettingsParamType.String,
  },
  imageRatio: {
    defaultValue: ImageRatio.square,
    key: 'imageRatio',
    type: EEditorSettingsParamType.String,
  },
};

export const text: TextSettings = {
  groupListTitle: {
    getDefaultValue: () => i18nInstance.t('groups-web.header'),
    key: 'groupListTitle',
    type: EEditorSettingsParamType.String,
  },
  groupMembersLabel: {
    defaultValue: 'Members',
    key: 'groupMembersLabel',
    type: EEditorSettingsParamType.String,
  },
};

export const design: DesignSettings = {
  text: {
    listTitle: {
      color: {
        key: 'listTitleColor',
        type: EEditorSettingsParamType.Color,
        defaultValue: 'color_25',
      },
      font: {
        key: 'listTitleFont',
        type: EEditorSettingsParamType.Font,
        defaultValue: 'Heading-M',
      },
    },
    groupName: {
      color: {
        key: 'groupNameColor',
        type: EEditorSettingsParamType.Color,
        defaultValue: 'color_25',
      },
      font: {
        key: 'groupNameFont',
        type: EEditorSettingsParamType.Font,
        defaultValue: 'Heading-L',
      },
    },
    colorOnHover: {
      key: 'groupNameColorOnHover',
      type: EEditorSettingsParamType.Color,
      defaultValue: 'color_34',
    },
    groupInfo: {
      color: {
        key: 'groupInfoColor',
        type: EEditorSettingsParamType.Color,
        defaultValue: 'color_14',
      },
      font: {
        key: 'groupInfoFont',
        type: EEditorSettingsParamType.Font,
        defaultValue: 'Body-L',
      },
    },
  },
  button: {
    color: {
      key: 'buttonColor',
      type: EEditorSettingsParamType.Color,
      defaultValue: 'color_5',
    },
    text: {
      color: {
        key: 'buttonTextColor',
        type: EEditorSettingsParamType.Color,
        defaultValue: 'color_1',
      },
      font: {
        key: 'buttonTextFont',
        type: EEditorSettingsParamType.Font,
        defaultValue: 'Body-M',
      },
    },
    borderRadius: {
      defaultValue: '0',
      key: 'buttonBorderRadius',
      type: EEditorSettingsParamType.String,
    },
  },
  backgroundBorder: {
    card: {
      background: {
        color: {
          key: 'cardBackgroundColor',
          type: EEditorSettingsParamType.Color,
          defaultValue: 'color_1',
        },
      },
    },
    app: {
      background: {
        color: {
          key: 'appBackgroundColor',
          type: EEditorSettingsParamType.Color,
          defaultValue: 'color_1',
        },
      },
    },
    border: {
      color: {
        key: 'borderColor',
        type: EEditorSettingsParamType.Color,
        defaultValue: 'color_1',
      },
      width: {
        key: 'borderWidth',
        type: EEditorSettingsParamType.Number,
        defaultValue: 1,
      },
    },
  },
};
